import { ServerTimeHelper, translate } from "@kaltura/mediaspace-shared-utils";
import AddToCalendarContainer from "./AddToCalendarContainer";
import { KmsTypeComponent, KmsTypeMediaSchedulingData } from "@kaltura/mediaspace-shared-types";
import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";

/**
 * get media status to pass from hero component to lobby component
 */
const getStatusLabel = (schedulingData?: KmsTypeMediaSchedulingData): string => {
    const isScheduled = !!schedulingData?.from && !!schedulingData?.to;
    const isSessionEnded = !!schedulingData?.to && ServerTimeHelper.getUpdatedTime() > schedulingData?.to;

    let statusLabel = "";

    if (isScheduled) {
        if (isSessionEnded) {
            statusLabel = translate("Session Ended");
        }
        else {
            statusLabel = translate("This Session will start soon");
        }
    }

    return statusLabel;
};

/**
 * get actions to pass from hero component to lobby component
 */
const getActions = (
    entry: KalturaBaseEntry,
    schedulingData?: KmsTypeMediaSchedulingData,
    actions?: KmsTypeComponent[],
    isReadOnly?: boolean
) => {
    let actionsToShow: KmsTypeComponent[] = [];

    // No "Add to Calendar" action if the session has ended or is read-only
    if (schedulingData && ServerTimeHelper.getUpdatedTime() < schedulingData.to && !isReadOnly) {
        actionsToShow = [
            {
                name: "calendar",
                component: AddToCalendarContainer,
                props: {
                    entry,
                },
            },
        ];
    }
    return [...actionsToShow, ...(actions ?? [])].filter((action) => action);
};

/**
 * single function for getting all props to pass from hero components to lobby component
 */
export const getPropsToPass = (
    entry: KalturaBaseEntry,
    schedulingData?: KmsTypeMediaSchedulingData,
    actions?: KmsTypeComponent[],
    isReadOnly?: boolean
) => {
    const statusLabel = getStatusLabel(schedulingData);
    const actionsToPass = getActions(entry, schedulingData, actions, isReadOnly);
    return { statusLabel, actionsToPass };
};

/**
 * hook for getting correct thumbnail size
 */
export const useThumbnailSizing = (thumbnailUrl: string) => thumbnailUrl + "/width/1600/height/900/type/3";
